import React from 'react';
import { UserCreateTemplate } from 'themes/modules/user/pages';
import { UserCreateViewStore } from 'modules/user/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new UserCreateViewStore(rootStore, componentProps), 'userCreateViewStore')
class UserCreate extends React.Component {
	render() {
		return <UserCreateTemplate {...this.props} />;
	}
}

export default UserCreate;
